import { render } from "./MassUpdateButtons.vue?vue&type=template&id=6f912905"
import script from "./MassUpdateButtons.vue?vue&type=script&lang=js"
export * from "./MassUpdateButtons.vue?vue&type=script&lang=js"

import exportComponent from "E:\\my project backsups\\vue\\vuestyle3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__